<ul ngbNav #nav="ngbNav" [(activeId)]="active"
  [ngClass]="'nav nav-tabs mb-2 ' + (this.invertColors ? 'invert-colors' : '') " [id]="this.id">
  <li class="nav-item" *ngFor="let item of this.tabs; let i = index" [ngbNavItem]="i">
    <a *ngIf="item !== null" ngbNavLink
      [ngClass]="'nav-link ' + (i == 0 ? 'active ' : '') + (!this.validTab(item.content) || item.invalid ? 'error' : '') ">
      <span (click)="(item.eventEmitter !== null && item.eventEmitter !== undefined ? item.eventEmitter.emit() : null)">
        <i *ngIf="!this.validTab(item.content)" class='ft-alert-circle mx-1'></i> {{item.label}}
      </span>
    </a>
  </li>
</ul>

<ng-template ngbNavContent *ngTemplateOutlet="tabs[active].content"></ng-template>
<!-- <div [ngbNavOutlet]="nav" class="mt-2"></div> -->
